import { render, staticRenderFns } from "./AppSettingList.vue?vue&type=template&id=72114d82&scoped=true&"
import script from "./AppSettingList.vue?vue&type=script&lang=js&"
export * from "./AppSettingList.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingList.vue?vue&type=style&index=0&id=72114d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72114d82",
  null
  
)

export default component.exports